/*
 * PFC mount hero — animated "fan of mounts" visual.
 *
 * Renders 3 mount cards (each a finish from window.PFC_MOUNT_HERO.cards) holding
 * the sample photo. The fan-out animation is pure CSS (see pfc-mount-hero.css);
 * this script only paints the mount canvases. Self-contained — shares the visual
 * conventions of pfc-mount-gallery.js but not its code.
 */
(function () {
  var root = document.querySelector('[data-pfc-mount-hero]');
  var cfg = window.PFC_MOUNT_HERO;
  var hasFinishes = cfg && ((Array.isArray(cfg.cyclePool) && cfg.cyclePool.length) || (Array.isArray(cfg.cards) && cfg.cards.length));
  if (!root || !hasFinishes) return;

  var STRIPE_BASE = '#fafaf6';
  var sampleImg = null;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mhero-card]'));

  function drawCover(ctx, img, dx, dy, dw, dh) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var s = Math.max(dw / iw, dh / ih);
    ctx.save();
    ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
    ctx.drawImage(img, dx + (dw - iw * s) / 2, dy + (dh - ih * s) / 2, iw * s, ih * s);
    ctx.restore();
  }

  function drawFinish(ctx, c, x0, y0, outerW, outerH, scale, bw, bh) {
    var band = c.band || '#23395d';
    if (c.kind === 'stripes') {
      var horiz = c.orient === 'h';
      var n = c.bandWidthMm ? Math.max(5, Math.round((horiz ? bh : bw) / c.bandWidthMm) | 1) : (c.bands || 19);
      if (horiz) {
        var bH = outerH / n;
        for (var hi = 0; hi < n; hi++) { ctx.fillStyle = (hi % 2 === 0) ? STRIPE_BASE : band; ctx.fillRect(x0, y0 + hi * bH, outerW, Math.ceil(bH) + 1); }
      } else {
        var bW = outerW / n;
        for (var i = 0; i < n; i++) { ctx.fillStyle = (i % 2 === 0) ? STRIPE_BASE : band; ctx.fillRect(x0 + i * bW, y0, Math.ceil(bW) + 1, outerH); }
      }
    } else if (c.kind === 'gingham') {
      var gcell = Math.max(5, (c.cellMm || 16) * scale);
      ctx.save(); ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      ctx.globalAlpha = 0.42; ctx.fillStyle = band;
      var gcols = Math.ceil(outerW / gcell), grows = Math.ceil(outerH / gcell);
      for (var gx = 0; gx < gcols; gx += 2) ctx.fillRect(x0 + gx * gcell, y0, Math.ceil(gcell) + 1, outerH);
      for (var gy = 0; gy < grows; gy += 2) ctx.fillRect(x0, y0 + gy * gcell, outerW, Math.ceil(gcell) + 1);
      ctx.globalAlpha = 1; ctx.restore();
    } else if (c.kind === 'polka') {
      var pcell = Math.max(7, (c.dotMm || 18) * scale), pr = pcell * 0.3;
      ctx.save(); ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip(); ctx.fillStyle = band;
      var prows = Math.ceil(outerH / pcell) + 1, pcols = Math.ceil(outerW / pcell) + 1;
      for (var pry = 0; pry < prows; pry++) for (var pcx = 0; pcx < pcols; pcx++) {
        var ox = x0 + pcx * pcell + (pry % 2 ? pcell / 2 : 0) + pcell / 2;
        ctx.beginPath(); ctx.arc(ox, y0 + pry * pcell + pcell / 2, pr, 0, Math.PI * 2); ctx.fill();
      }
      ctx.restore();
    } else if (c.kind === 'checkers') {
      var cell = Math.max(5, (c.checkMm || 15) * scale);
      var cols = Math.ceil(outerW / cell), rows = Math.ceil(outerH / cell);
      ctx.save(); ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip(); ctx.fillStyle = band;
      for (var ry = 0; ry < rows; ry++) for (var cx = 0; cx < cols; cx++) {
        if ((cx + ry) % 2 === 0) continue;
        ctx.fillRect(x0 + cx * cell, y0 + ry * cell, Math.ceil(cell) + 1, Math.ceil(cell) + 1);
      }
      ctx.restore();
    } else if (c.kind === 'chevron') {
      var amp = Math.max(4, (c.bandMm || 14) * scale);
      ctx.save(); ctx.beginPath(); ctx.rect(x0, y0, outerW, outerH); ctx.clip();
      ctx.strokeStyle = band; ctx.lineWidth = Math.max(2, amp * 0.5); ctx.lineCap = 'butt';
      for (var cyy = y0 - outerH; cyy < y0 + outerH * 2; cyy += amp * 2) {
        ctx.beginPath(); var up = true;
        for (var cxx = x0; cxx <= x0 + outerW + amp; cxx += amp) { var cpy = cyy + (up ? 0 : amp); if (cxx === x0) ctx.moveTo(cxx, cpy); else ctx.lineTo(cxx, cpy); up = !up; }
        ctx.stroke();
      }
      ctx.restore();
    }
  }

  function renderCard(canvas, c) {
    var ctx = canvas.getContext('2d'); if (!ctx || !c) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.max(80, Math.round(canvas.clientWidth || 200));
    var H = Math.max(80, Math.round(canvas.clientHeight || 280));
    if (canvas.width !== W * dpr || canvas.height !== H * dpr) { canvas.width = W * dpr; canvas.height = H * dpr; }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);

    var bw = cfg.board.w, bh = cfg.board.h;
    var scale = Math.min(W / bw, H / bh) * 0.98;
    var outerW = bw * scale, outerH = bh * scale;
    var x0 = (W - outerW) / 2, y0 = (H - outerH) / 2;

    ctx.save();
    ctx.shadowColor = 'rgba(50,38,20,0.30)'; ctx.shadowBlur = 26; ctx.shadowOffsetY = 16;
    ctx.fillStyle = (c.kind === 'plain') ? (c.hex || '#fafaf6') : STRIPE_BASE;
    ctx.fillRect(x0, y0, outerW, outerH);
    ctx.restore();

    drawFinish(ctx, c, x0, y0, outerW, outerH, scale, bw, bh);

    var surf = ctx.createLinearGradient(x0, y0, x0, y0 + outerH);
    surf.addColorStop(0, 'rgba(255,255,255,0.10)'); surf.addColorStop(1, 'rgba(0,0,0,0.06)');
    ctx.fillStyle = surf; ctx.fillRect(x0, y0, outerW, outerH);
    ctx.strokeStyle = 'rgba(0,0,0,0.12)'; ctx.lineWidth = 1; ctx.strokeRect(x0 + 0.5, y0 + 0.5, outerW - 1, outerH - 1);

    var apW = Math.min(cfg.opening.w * scale, outerW * 0.9), apH = Math.min(cfg.opening.h * scale, outerH * 0.9);
    var apX = x0 + (outerW - apW) / 2, apY = y0 + (outerH - apH) / 2;
    var bevel = Math.max(1.5, Math.min(outerW, outerH) * 0.012);
    var inX = apX + bevel, inY = apY + bevel, inW = Math.max(2, apW - bevel * 2), inH = Math.max(2, apH - bevel * 2);

    ctx.fillStyle = '#ffffff'; ctx.fillRect(apX, apY, apW, apH);
    if (sampleImg) drawCover(ctx, sampleImg, inX, inY, inW, inH);
    else { ctx.fillStyle = '#f0ece3'; ctx.fillRect(inX, inY, inW, inH); }
    ctx.strokeStyle = 'rgba(0,0,0,0.28)'; ctx.lineWidth = 1; ctx.strokeRect(inX + 0.5, inY + 0.5, inW - 1, inH - 1);

    if (c.kind === 'accent') {
      var gap = Math.max(3, (c.gapMm || 10) * scale), lw = Math.max(1, (c.lineMm || 1.4) * scale);
      var lx = apX - gap, ly = apY - gap, lwd = apW + gap * 2, lht = apH + gap * 2;
      if (lx > x0 + 2 && ly > y0 + 2) { ctx.strokeStyle = c.band; ctx.lineWidth = lw; ctx.strokeRect(lx, ly, lwd, lht); }
    }
  }

  /* ---------- Cross-fade cycling ---------- */
  var POOL = (cfg.cyclePool && cfg.cyclePool.length) ? cfg.cyclePool : null;
  var CYC = cfg.cycle || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fallbackFinish(i) { return (cfg.cards && cfg.cards[i]) || { kind: 'plain', hex: '#fafaf6' }; }

  // Each card owns two stacked canvas layers we cross-fade between, a pointer
  // into the pool, and the finish currently on its active layer.
  var cardState = cards.map(function (el) {
    return { el: el, layers: el.querySelectorAll('canvas'), active: 0, ptr: 0, finish: null };
  });
  function offsetFor(i) { return POOL ? (i * Math.floor(POOL.length / cardState.length)) % POOL.length : 0; }
  cardState.forEach(function (s, i) {
    s.ptr = offsetFor(i);
    s.finish = POOL ? POOL[s.ptr] : fallbackFinish(i);
    renderCard(s.layers[0], s.finish);
  });

  function rerenderActive() { cardState.forEach(function (s) { renderCard(s.layers[s.active], s.finish); }); }

  function cycleCard(i) {
    var s = cardState[i];
    if (!POOL) return;
    s.ptr = (s.ptr + 1) % POOL.length;
    s.finish = POOL[s.ptr];
    var next = 1 - s.active;
    renderCard(s.layers[next], s.finish);
    s.layers[next].style.opacity = '1';
    s.layers[s.active].style.opacity = '0';
    s.active = next;
  }

  /* ---------- Sample photo + reaction to gallery uploads ---------- */
  function loadSample(src) {
    if (!src) return;
    var im = new Image();
    im.onload = function () { sampleImg = im; rerenderActive(); };
    im.crossOrigin = 'anonymous';
    im.src = src;
  }
  loadSample(cfg.sample);
  window.addEventListener('pfc-mount-sample', function (e) {
    var d = (e && e.detail) || {};
    if (d.isPlaceholder) loadSample(cfg.sample);   // reverted → hero's own sample
    else if (d.src) loadSample(d.src);             // visitor's uploaded photo
  });

  /* ---------- Slow loop: start after the deal settles, pause when tab hidden ---------- */
  if (POOL && CYC.enabled !== false && !reduceMotion) {
    var intervalMs = CYC.intervalMs || 3800;
    var staggerMs = CYC.staggerMs || 240;
    var startDelayMs = CYC.startDelayMs || 2800;
    var tick = function () {
      if (document.hidden) return;
      cardState.forEach(function (_, i) { setTimeout(function () { cycleCard(i); }, i * staggerMs); });
    };
    setTimeout(function () { setInterval(tick, intervalMs); }, startDelayMs);
  }

  var raf = null;
  window.addEventListener('resize', function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(rerenderActive);
  });
})();
